<template>
  <div id="main-content" class="attachment-file-page">
    <el-col :offset="1" :span="22">
      <PageTitle :title="title" :backLink="backLink"></PageTitle>

      <!--For parent-->
      <el-row class="row-section">
        <h3>{{ $t('common.parent') }}</h3>
      </el-row>
      <el-row class="row-section" style="height: 55px; padding-top: 0px">
        <el-col :span="20" style="display: inline">
          <el-col :span="2">
            <span class="form-lable" style="color: #000">{{ $t('common.title') }}</span>
          </el-col>
          <el-col :span="7">
            <input style="width: 100%; color: #000" class="input" v-model="newParentFile.title" type=""/>
          </el-col>
          <el-col :span="2" class="error-section">
            <span v-for="(value, key) in error_message.newParentFile.title" :key="key" class="form-error"> {{ value }}</span>
          </el-col>
          <el-col :span="2" :offset="2">
            <span class="form-lable" style="color: #000">{{ $t('common.file') }}</span>
          </el-col>
          <el-col :span="7">
            <b-form-file
              id="parentFile"
              accept=".pdf"
              v-model="newParentFile.file"
              style="width: 100%; float: left"
              :placeholder="$t('common.choose_file')"
              :drop-placeholder="$t('common.drop_file')"
            >
              <template slot="file-name" slot-scope="{ names }">
                {{ formatName(names[0], 14) }}
              </template>
            </b-form-file>
          </el-col>
          <el-col :span="2" class="error-section">
            <span v-for="(value, key) in error_message.newParentFile.file" :key="key" class="form-error"> {{ value }}</span>
          </el-col>
        </el-col>
        <el-col :span="4">
          <el-button @click="addNewFile('newParentFile')" style="float: left; margin-left: 20px;" type="success"
                     icon="el-icon-plus"
                     circle></el-button>
          <span style="line-height: 40px;margin-left: 20px; font-size: 22px">{{ $t('common.add_new_file') }}</span>
        </el-col>
      </el-row>
      <el-row style="padding-top: 20px">
        <table class="bus-list">
          <tr>
            <th width="5%">#</th>
            <th width="30%">{{ $t('common.title') }}</th>
            <th width="25%">{{ $t('common.file') }}</th>
            <th width="25%">{{ $t('common.creation_time') }}</th>
            <th></th>
          </tr>
          <tr v-for="(attachment, index) in sortedAttachmentForParentList" :key="attachment.id">
            <td width="5%">{{ index + 1 }}</td>
            <td>
              <span v-show="!attachment.isEditState">{{ attachment.title }}</span>
              <input v-show="attachment.isEditState" style="width: 70%; color: #000; float: none"
                     class="input" v-model="attachment.newTitle" type=""/>
            </td>
            <td>
              <b-form-file
                v-if="attachment.isEditState"
                v-model="attachment.newFile"
                accept=".pdf"
                :placeholder="$t('common.choose_file')"
                :drop-placeholder="$t('common.drop_file')"
              >
                <template slot="file-name" slot-scope="{ names }">
                  {{ formatName(names[0], 12) }}
                </template>
              </b-form-file>
              <el-button v-if="!attachment.isEditState" type="success"
                         @click="goToViewFile(attachment.file_url)" icon="el-icon-view">
                {{ $t('common.view') }}
              </el-button>
            </td>
            <td>{{ attachment.created_at }}</td>
            <td>
              <b-button v-if="attachment.isEditState"
                        variant="success" @click="saveEdit(attachment)"
                        style="margin-right: 10px">{{ $t('common.save') }}
              </b-button>
              <b-button v-if="attachment.isEditState"
                        variant="primary" @click="showEdit(attachment, false)"
                        style="margin-right: 10px">{{ $t('common.cancel') }}
              </b-button>
              <b-button v-if="!attachment.isEditState"
                        variant="outline-primary"
                        @click="showEdit(attachment, true)"
                        style="margin-right: 10px">{{ $t('common.edit') }}
              </b-button>
              <b-button v-if="attachment.is_disabled" variant="primary"
                        style="margin-right: 10px"
                        @click="enableAttachment(attachment)">{{ $t('common.enable') }}
              </b-button>
              <b-button v-else variant="warning"
                        style="margin-right: 10px"
                        @click="disableAttachment(attachment)">{{ $t('common.disable') }}
              </b-button>
              <b-button v-if="!attachment.isEditState" variant="danger"
                        @click="deleteAttachment(attachment, 'attachmentForParentList')">{{ $t('common.delete') }}
              </b-button>
            </td>
          </tr>
        </table>
      </el-row>

      <!--For sub -->
      <el-row class="row-section">
        <h3>{{ $t('common.sub_driver') }}</h3>
      </el-row>
      <el-row class="row-section" style="height: 55px; padding-top: 0px">
        <el-col :span="20" style="display: inline">
          <el-col :span="2">
            <span class="form-lable" style="color: #000">{{ $t('common.title') }}</span>
          </el-col>
          <el-col :span="7">
            <input style="width: 100%; color: #000" class="input" v-model="newSubFile.title" type=""/>
          </el-col>
          <el-col :span="2" class="error-section">
            <span v-for="(value, key) in error_message.newSubFile.title" :key="key" class="form-error"> {{ value }}</span>
          </el-col>
          <el-col :span="2" :offset="2">
            <span class="form-lable" style="color: #000">{{ $t('common.file') }}</span>
          </el-col>
          <el-col :span="7">
            <b-form-file
              id="subFile"
              v-model="newSubFile.file"
              accept=".pdf"
              style="width: 100%; float: left"
              :placeholder="$t('common.choose_file')"
              :drop-placeholder="$t('common.drop_file')"
            >
              <template slot="file-name" slot-scope="{ names }">
                {{ formatName(names[0], 14) }}
              </template>
            </b-form-file>
          </el-col>
          <el-col :span="2" class="error-section">
            <span v-for="(value, key) in error_message.newSubFile.file" :key="key" class="form-error"> {{ value }}</span>
          </el-col>
        </el-col>
        <el-col :span="4">
          <el-button @click="addNewFile('newSubFile')" style="float: left; margin-left: 20px;" type="success"
                     icon="el-icon-plus"
                     circle></el-button>
          <span style="line-height: 40px;margin-left: 20px; font-size: 22px">{{ $t('common.add_new_file') }}</span>
        </el-col>
      </el-row>
      <el-row style="padding-top: 20px">
        <table class="bus-list">
          <tr>
            <th width="5%">#</th>
            <th width="30%">{{ $t('common.title') }}</th>
            <th width="25%">{{ $t('common.file') }}</th>
            <th width="25%">{{ $t('common.creation_time') }}</th>
            <th></th>
          </tr>
          <tr v-for="(attachment, index) in sortedAttachmentForSubList" :key="attachment.id">
            <td width="5%">{{ index + 1 }}</td>
            <td>
              <span v-show="!attachment.isEditState">{{ attachment.title }}</span>
              <input v-show="attachment.isEditState" style="width: 70%; color: #000; float: none"
                     class="input" v-model="attachment.newTitle" type=""/>
            </td>
            <td>
              <b-form-file
                v-if="attachment.isEditState"
                v-model="attachment.newFile"
                accept=".pdf"
                :placeholder="$t('common.choose_file')"
                :drop-placeholder="$t('common.drop_file')"
              >
                <template slot="file-name" slot-scope="{ names }">
                  {{ formatName(names[0], 12) }}
                </template>
              </b-form-file>
              <el-button v-if="!attachment.isEditState" type="success"
                         @click="goToViewFile(attachment.file_url)" icon="el-icon-view">
                {{ $t('common.view') }}
              </el-button>
            </td>
            <td>{{ attachment.created_at }}</td>
            <td>
              <b-button v-if="attachment.isEditState"
                        variant="success" @click="saveEdit(attachment)"
                        style="margin-right: 10px">{{ $t('common.save') }}
              </b-button>
              <b-button v-if="attachment.isEditState"
                        variant="primary" @click="showEdit(attachment, false)"
                        style="margin-right: 10px">{{ $t('common.cancel') }}
              </b-button>
              <b-button v-if="!attachment.isEditState"
                        variant="outline-primary" @click="showEdit(attachment, true)"
                        style="margin-right: 10px">{{ $t('common.edit') }}
              </b-button>
              <b-button v-if="attachment.is_disabled" variant="primary"
                        style="margin-right: 10px"
                        @click="enableAttachment(attachment)">{{ $t('common.enable') }}
              </b-button>
              <b-button v-else variant="warning"
                        style="margin-right: 10px"
                        @click="disableAttachment(attachment)">{{ $t('common.disable') }}
              </b-button>
              <b-button v-if="!attachment.isEditState" variant="danger"
                        @click="deleteAttachment(attachment, 'attachmentForSubList')">{{ $t('common.delete') }}
              </b-button>
            </td>
          </tr>
        </table>
      </el-row>

      <!--For route-->
      <el-row class="row-section">
        <h3>{{ $t('common.pickup_route') }}</h3>
      </el-row>
      <el-row class="row-section" style="height: 55px; padding-top: 0px">
        <el-col :span="7">
          <el-row>
            <el-col :span="6">
              <span class="form-lable" style="color: #000">{{ $t('common.title') }}</span>
            </el-col>
            <el-col :span="18">
              <input style="width: 100%; color: #000" class="input" v-model="newRouteFile.title" type=""/>
            </el-col>
          </el-row>
          <el-row>
            <el-col :offset="6" :span="18" class="error-section">
              <span v-for="(value, key) in error_message.newRouteFile.title" :key="key" class="form-error"> {{ value }}</span>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="5" :offset="1">
          <el-row>
            <el-col :span="6">
              <span class="form-lable" style="color: #000">{{ $t('common.route') }}</span>
            </el-col>
            <el-col :span="18">
              <el-select v-model="newRouteFile.route_id" :placeholder="$t('common.pickup_route')">
                <el-option
                    v-for="route in sortedPickupRouteList"
                    :key="route.id"
                    :label="route.name"
                    :value="route.id">
                </el-option>
              </el-select>
            </el-col>
          </el-row>
          <el-row>
            <el-col :offset="6" :span="18" class="error-section">
              <span v-for="(value, key) in error_message.newRouteFile.routeId" :key="key" class="form-error"> {{ value }}</span>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="5" :offset="1">
          <el-row>
            <el-col :span="6">
              <span class="form-lable" style="color: #000">{{ $t('common.file') }}</span>
            </el-col>
            <el-col :span="18">
              <b-form-file
                      id="subFile"
                      v-model="newRouteFile.file"
                      accept=".pdf"
                      style="width: 100%; float: left"
                      :placeholder="$t('common.choose_file')"
                      :drop-placeholder="$t('common.drop_file')"
              >
                <template slot="file-name" slot-scope="{ names }">
                  {{ formatName(names[0], 7) }}
                </template>
              </b-form-file>
            </el-col>
            <el-col :span="18" :offset="6" class="error-section">
              <span v-for="(value, key) in error_message.newRouteFile.file" :key="key" class="form-error"> {{ value }}</span>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="4" :offset="1">
          <el-button @click="addNewFile('newRouteFile')" style="float: left; margin-left: 20px;" type="success"
                     icon="el-icon-plus"
                     circle></el-button>
          <span style="line-height: 40px;margin-left: 20px; font-size: 22px">{{ $t('common.add_new_file') }}</span>
        </el-col>
      </el-row>
      <el-row style="padding-top: 20px">
        <table class="bus-list">
          <tr>
            <th width="5%">#</th>
            <th width="20%">{{ $t('common.title') }}</th>
            <th width="20%">{{ $t('common.pickup_route_name') }}</th>
            <th width="15%">{{ $t('common.file') }}</th>
            <th width="20%">{{ $t('common.creation_time') }}</th>
            <th></th>
          </tr>
          <tr v-for="(attachment, index) in sortedAttachmentForRouteList" :key="attachment.id"
              v-show="index >= itemPerPage * (currentPageRoute - 1) && index < itemPerPage * currentPageRoute">
            <td width="5%">{{ index + 1 }}</td>
            <td>
              <span v-show="!attachment.isEditState">{{ attachment.title }}</span>
              <input v-show="attachment.isEditState" style="width: 70%; color: #000; float: none"
                     class="input" v-model="attachment.newTitle" type=""/>
            </td>
            <td>
              {{ attachment.pickup_route_info ? attachment.pickup_route_info.name : '' }}
            </td>
            <td>
              <b-form-file
                v-if="attachment.isEditState"
                v-model="attachment.newFile"
                accept=".pdf"
                :placeholder="$t('common.choose_file')"
                :drop-placeholder="$t('common.drop_file')"
              >
                <template slot="file-name" slot-scope="{ names }">
                  {{ formatName(names[0], 4) }}
                </template>
              </b-form-file>
              <el-button v-if="!attachment.isEditState && attachment.file_url !== ''" type="success"
                         @click="goToViewFile(attachment.file_url)" icon="el-icon-view">
                {{ $t('common.view') }}
              </el-button>
              <span v-if="!attachment.isEditState && attachment.file_url === ''">
                {{ $t('common.no_file_uploaded') }}
              </span>
            </td>
            <td>{{ attachment.created_at }}</td>
            <td>
              <b-button v-if="attachment.isEditState"
                        variant="success" @click="saveEdit(attachment)"
                        style="margin-right: 10px">{{ $t('common.save') }}
              </b-button>
              <b-button v-if="attachment.isEditState"
                        variant="primary" @click="showEdit(attachment, false)"
                        style="margin-right: 10px">{{ $t('common.cancel') }}
              </b-button>
              <b-button v-if="!attachment.isEditState"
                        variant="outline-primary"
                        @click="showEdit(attachment, true)"
                        style="margin-right: 10px">{{ $t('common.edit') }}
              </b-button>
              <b-button v-if="attachment.is_disabled" variant="primary"
                        style="margin-right: 10px"
                        @click="enableAttachment(attachment)">{{ $t('common.enable') }}
              </b-button>
              <b-button v-else variant="warning"
                        style="margin-right: 10px"
                        @click="disableAttachment(attachment)">{{ $t('common.disable') }}
              </b-button>
              <b-button v-if="!attachment.isEditState && attachment.file_url !== ''" variant="danger"
                        @click="deleteAttachment(attachment, 'attachmentForRouteList')">{{ $t('common.delete') }}
              </b-button>
            </td>
          </tr>

        </table>
      </el-row>
      <el-row style="padding-top: 15px">
        <el-pagination
        v-show="sortedAttachmentForRouteList.length > itemPerPage"
        background
        @current-change="didSelectPage"
        :page-size="itemPerPage"
        layout="prev, pager, next"
        :current-page="currentPageRoute"
        :total="sortedAttachmentForRouteList.length">
        </el-pagination>
      </el-row>

      <el-row class="row-section">
        <h3>{{ $t('common.drop_route') }}</h3>
      </el-row>
      <el-row class="row-section" style="height: 55px; padding-top: 0px">
        <el-col :span="7">
          <el-row>
            <el-col :span="6">
              <span class="form-lable" style="color: #000">{{ $t('common.title') }}</span>
            </el-col>
            <el-col :span="18">
              <input style="width: 100%; color: #000" class="input" v-model="newDropRouteFile.title" type=""/>
            </el-col>
          </el-row>
          <el-row>
            <el-col :offset="6" :span="18" class="error-section">
              <span v-for="(value, key) in error_message.newDropRouteFile.title" :key="key" class="form-error"> {{ value }}</span>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="5" :offset="1">
          <el-row>
            <el-col :span="6">
              <span class="form-lable" style="color: #000">{{ $t('common.route') }}</span>
            </el-col>
            <el-col :span="18">
              <el-select v-model="newDropRouteFile.route_id" :placeholder="$t('common.drop_route')">
                <el-option
                        v-for="route in sortedDropRouteList"
                        :key="route.id"
                        :label="route.name"
                        :value="route.id">
                </el-option>
              </el-select>
            </el-col>
          </el-row>
          <el-row>
            <el-col :offset="6" :span="18" class="error-section">
              <span v-for="(value, key) in error_message.newDropRouteFile.routeId" :key="key" class="form-error"> {{ value }}</span>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="5" :offset="1">
          <el-row>
            <el-col :span="6">
              <span class="form-lable" style="color: #000">{{ $t('common.file') }}</span>
            </el-col>
            <el-col :span="18">
              <b-form-file
                      id="subFile"
                      v-model="newDropRouteFile.file"
                      accept=".pdf"
                      style="width: 100%; float: left"
                      :placeholder="$t('common.choose_file')"
                      :drop-placeholder="$t('common.drop_file')"
              >
                <template slot="file-name" slot-scope="{ names }">
                  {{ formatName(names[0], 7) }}
                </template>
              </b-form-file>
            </el-col>
            <el-col :span="18" :offset="6" class="error-section">
              <span v-for="(value, key) in error_message.newDropRouteFile.file" :key="key" class="form-error"> {{ value }}</span>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="4" :offset="1">
          <el-button @click="addNewFile('newDropRouteFile')" style="float: left; margin-left: 20px;" type="success"
                     icon="el-icon-plus"
                     circle></el-button>
          <span style="line-height: 40px;margin-left: 20px; font-size: 22px">{{ $t('common.add_new_file') }}</span>
        </el-col>
      </el-row>
      <el-row style="padding-top: 20px">
        <table class="bus-list">
          <tr>
            <th width="5%">#</th>
            <th width="20%">{{ $t('common.title') }}</th>
            <th width="20%">{{ $t('common.drop_route_name') }}</th>
            <th width="15%">{{ $t('common.file') }}</th>
            <th width="20%">{{ $t('common.creation_time') }}</th>
            <th></th>
          </tr>
          <tr v-for="(attachment, index) in sortedAttachmentForDropRouteList" :key="attachment.id"
              v-show="index >= itemPerPage * (currentPageDropRoute - 1) && index < itemPerPage * currentPageDropRoute">
            <td width="5%">{{ index + 1 }}</td>
            <td>
              <span v-show="!attachment.isEditState">{{ attachment.title }}</span>
              <input v-show="attachment.isEditState" style="width: 70%; color: #000; float: none"
                     class="input" v-model="attachment.newTitle" type=""/>
            </td>
            <td>
              {{ attachment.drop_route_info ? attachment.drop_route_info.name : '' }}
            </td>
            <td>
              <b-form-file
                      v-if="attachment.isEditState"
                      v-model="attachment.newFile"
                      accept=".pdf"
                      :placeholder="$t('common.choose_file')"
                      :drop-placeholder="$t('common.drop_file')"
                      :file-name-formatter="formatName"
              >
                <template slot="file-name" slot-scope="{ names }">
                  {{ formatName(names[0], 4) }}
                </template>
              </b-form-file>
              <el-button v-if="!attachment.isEditState && attachment.file_url !== ''" type="success"
                         @click="goToViewFile(attachment.file_url)" icon="el-icon-view">
                {{ $t('common.view') }}
              </el-button>
              <span v-if="!attachment.isEditState && attachment.file_url === ''">
                {{ $t('common.no_file_uploaded') }}
              </span>
            </td>
            <td>{{ attachment.created_at }}</td>
            <td>
              <b-button v-if="attachment.isEditState"
                        variant="success" @click="saveEdit(attachment)"
                        style="margin-right: 10px">{{ $t('common.save') }}
              </b-button>
              <b-button v-if="attachment.isEditState"
                        variant="primary" @click="showEdit(attachment, false)"
                        style="margin-right: 10px">{{ $t('common.cancel') }}
              </b-button>
              <b-button v-if="!attachment.isEditState"
                        variant="outline-primary"
                        @click="showEdit(attachment, true)"
                        style="margin-right: 10px">{{ $t('common.edit') }}
              </b-button>
              <b-button v-if="attachment.is_disabled" variant="primary"
                        style="margin-right: 10px"
                        @click="enableAttachment(attachment)">{{ $t('common.enable') }}
              </b-button>
              <b-button v-else variant="warning"
                        style="margin-right: 10px"
                        @click="disableAttachment(attachment)">{{ $t('common.disable') }}
              </b-button>
              <b-button v-if="!attachment.isEditState && attachment.file_url !== ''" variant="danger"
                        @click="deleteAttachment(attachment, 'attachmentForDropRouteList')">{{ $t('common.delete') }}
              </b-button>
            </td>
          </tr>

        </table>
      </el-row>
      <el-row style="padding-top: 15px">
        <el-pagination
                v-show="sortedAttachmentForDropRouteList.length > itemPerPage"
                background
                @current-change="didSelectPageDropRoute"
                :page-size="itemPerPage"
                layout="prev, pager, next"
                :current-page="currentPageDropRoute"
                :total="sortedAttachmentForDropRouteList.length">
        </el-pagination>
      </el-row>
    </el-col>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  import {
    ITEM_PER_PAGE,
    ATTACHMENT_TYPE_SUB_DRIVER,
    ATTACHMENT_TYPE_PARENT,
    ATTACHMENT_TYPE_PICKUP_ROUTE,
    ATTACHMENT_TYPE_DROP_ROUTE,
    FLAG_NO,
    FLAG_YES
  } from '@/config'
  import PageTitle from '@/components/PageTitle'

  export default {
    name: 'AttachmentFileUser',
    components: {
      PageTitle
    },
    data: function () {
      return {
        backLink: ``,
        title: 'common.attachment_list',
        currentPageRoute: 1,
        currentPageDropRoute: 1,
        itemPerPage: ITEM_PER_PAGE,
        newParentFile: {
          title: '',
          file: null,
          type: ATTACHMENT_TYPE_PARENT
        },
        newSubFile: {
          title: '',
          file: null,
          type: ATTACHMENT_TYPE_SUB_DRIVER
        },
        newRouteFile: {
          title: '',
          file: null,
          type: ATTACHMENT_TYPE_PICKUP_ROUTE,
          route_id: null
        },
        newDropRouteFile: {
          title: '',
          file: null,
          type: ATTACHMENT_TYPE_DROP_ROUTE,
          route_id: null
        },
        currentKeyRoute: 0,
        pickupRouteFile: {},
        dropRouteFile: {},
        error_message: {
          newParentFile: {
            title: [],
            file: []
          },
          newSubFile: {
            title: [],
            file: []
          },
          newRouteFile: {
            title: [],
            file: [],
            routeId: []
          },
          newDropRouteFile: {
            title: [],
            file: [],
            routeId: []
          }
        }
      }
    },
    methods: {
      formatName (name, max) {
        if (name.length <= max) {
          return name
        }

        return name.substr(0, max) + '...'
      },
      saUpFileForRoute(index) {
        this.newRouteFile.title = this.pickupRouteList[index].name
        this.newRouteFile.file = this.pickupRouteList[index].newFile
        this.newRouteFile.route_id = this.pickupRouteList[index].id

        var formData = new FormData()
        for (const [key, value] of Object.entries(this.newRouteFile)) {
          formData.append(key, value)
        }
        let successCallback = (response) => {
          let id = this.pickupRouteList[index].id
          this.pickupRouteList[index].id = null
          this.pickupRouteList[index].id = id
          this.pickupRouteList[index].isEditState = false
          this.pickupRouteList[index].newFile = null
          this.pickupRouteList[index].file_url = response.data.data.attachment_user_info.file_url
          this.pickupRouteList[index].created_at = response.data.data.attachment_user_info.created_at
          this.pickupRouteList[index].attachment_id = response.data.data.attachment_user_info.id
        }
        let payload = {
          successCallback,
          attachment_user_file: formData,
          index: index,
        }

        if (this.pickupRouteList[index].attachment_id !== '') {
          payload.attachment_id = this.pickupRouteList[index].attachment_id
          this.$store.dispatch('attachmentfile/editAttachmentUser', payload);
        } else {
          this.$store.dispatch('attachmentfile/createAttachmentUser', payload);
        }

      },
      saUpFileForDropRoute(index) {
        this.newDropRouteFile.title = this.dropRouteList[index].name
        this.newDropRouteFile.file = this.dropRouteList[index].newFile
        this.newDropRouteFile.route_id = this.dropRouteList[index].id

        var formData = new FormData()
        for (const [key, value] of Object.entries(this.newDropRouteFile)) {
          formData.append(key, value)
        }
        let successCallback = (response) => {
          let id = this.dropRouteList[index].id
          this.dropRouteList[index].id = null
          this.dropRouteList[index].id = id
          this.dropRouteList[index].isEditState = false
          this.dropRouteList[index].newFile = null
          this.dropRouteList[index].file_url = response.data.data.attachment_user_info.file_url
          this.dropRouteList[index].created_at = response.data.data.attachment_user_info.created_at
          this.dropRouteList[index].attachment_id = response.data.data.attachment_user_info.id
        }
        let payload = {
          successCallback,
          attachment_user_file: formData,
          index: index,
        }

        if (this.dropRouteList[index].attachment_id !== '') {
          payload.attachment_id = this.dropRouteList[index].attachment_id
          this.$store.dispatch('attachmentfile/editAttachmentUser', payload);
        } else {
          this.$store.dispatch('attachmentfile/createAttachmentUser', payload);
        }

      },
      showEdit(attachment, isEdit) {
        let id = attachment.id
        attachment.id = null
        attachment.id = id
        attachment.isEditState = isEdit
      },
      saveEdit(attachment) {
        this.$store.commit('openConfirm', {
          title: this.$t('common.add_new_file'),
          message: this.$t('common.upload_file_confirm'),
          callback: () => {
            let payload = {
              attachment_user_file: attachment,
              attachment_id: attachment.id
            }
            var formData = new FormData()

            formData.append('file', payload.attachment_user_file.newFile)
            formData.append('title', payload.attachment_user_file.newTitle)
            formData.append('type', payload.attachment_user_file.type)
            payload.attachment_user_file = formData

            this.showEdit(attachment, false)
            this.$store.dispatch('attachmentfile/editAttachmentUser', payload)
          }
        })
      },
      goToViewFile(file_url) {
        window.open(file_url, '_blank')
      },
      didSelectPage: function (e) {
        this.currentPageRoute = e
      },
      didSelectPageDropRoute: function (e) {
        this.currentPageDropRoute = e
      },
      deleteAttachment(attachment, type) {
        this.$store.commit('openConfirm', {
          title: this.$t('common.delete'),
          message: this.$t('common.file_delete_confirm'),
          callback: () => {
            let successCallback = () => {

            }

            let payload = {
              successCallback,
              attachment_id: attachment.attachment_id || attachment.id,
              type: type
            }

            this.$store.dispatch('attachmentfile/deleteAttachmentUser', payload)
          }
        })
      },
      addNewFile(type) {
        this.$store.commit('openConfirm', {
          title: this.$t('common.add_new_file'),
          message: this.$t('common.upload_file_confirm'),
          callback: () => {
            let check = true

            if (check) {
              let successCallback = () => {
                this[type].title = ''
                this[type].file = null
              }
              let payload = {
                successCallback,
                attachment_user_file: null
              }
              payload.attachment_user_file = this[type]

              var formData = new FormData()
              for (const [key, value] of Object.entries(payload.attachment_user_file)) {
                if (value) {
                  formData.append(key, value)
                }
              }
              // formData.append('route_id', '')
              payload.attachment_user_file = formData
              this.$store.dispatch('attachmentfile/createAttachmentUser', payload)
            }
          }
        })
      },
      validate (type) {
        Object.keys(this.error_message).forEach((key) => {
          Object.keys(this.error_message[key]).forEach((subKey) => {
            this.error_message[key][subKey] = []
          })
        })

        if (this[type].title.trim() === "") {
          this.$store.commit('openNotification', {
            type: 'error',
            message: this.$t('common.please_check_input_error')
          })

          this.error_message[type].title.push('* ' + this.$t('common.title_is_required'))

          return false
        }

        if (!this[type].file) {
          this.$store.commit('openNotification', {
            type: 'error',
            message: this.$t('common.please_check_input_error')
          })

          this.error_message[type].file.push('* ' + this.$t('common.file_is_required'))

          return false
        }

        return true
      },
      computePickupList: function () {
        for (const[key, value] of Object.entries(this.pickupRouteList)) {
          var position = this.attachmentForRouteList.findIndex(x => x.route_id == value.id)
          this.pickupRouteList[key].isEditState = false
          this.pickupRouteList[key].title = value.name
          this.pickupRouteList[key].type = 2
          if (position > -1) {
            this.pickupRouteList[key].file_url = this.attachmentForRouteList[position].file_url
            this.pickupRouteList[key].attachment_id = this.attachmentForRouteList[position].id
            this.pickupRouteList[key].created_at = this.attachmentForRouteList[position].created_at
          } else {
            this.pickupRouteList[key].file_url = ''
            this.pickupRouteList[key].attachment_id = ''
            this.pickupRouteList[key].created_at = ''
          }
        }
      },
      computeDropList: function () {
        for (const[key, value] of Object.entries(this.dropRouteList)) {
          var position = this.attachmentForDropRouteList.findIndex(x => x.route_id == value.id)
          this.dropRouteList[key].isEditState = false
          this.dropRouteList[key].title = value.name
          this.dropRouteList[key].type = 2
          if (position > -1) {
            this.dropRouteList[key].file_url = this.attachmentForDropRouteList[position].file_url
            this.dropRouteList[key].attachment_id = this.attachmentForDropRouteList[position].id
            this.dropRouteList[key].created_at = this.attachmentForDropRouteList[position].created_at
          } else {
            this.dropRouteList[key].file_url = ''
            this.dropRouteList[key].attachment_id = ''
            this.dropRouteList[key].created_at = ''
          }
        }
      },
      enableAttachment (attachment) {
        this.$store.commit('openConfirm', {
          title: this.$t('common.confirm'),
          message: this.$t('common.enable_attachment_confirm'),
          callback: () => {
            let payload = {
              id: attachment.id,
              data: {
                is_disabled: FLAG_NO
              },
              successCallback: () => {
                attachment.is_disabled = FLAG_NO
              }
            }

            this.$store.dispatch('attachmentfile/updateAttachmentStatus', payload)
          }
        })
      },
      disableAttachment (attachment) {
        this.$store.commit('openConfirm', {
          title: this.$t('common.confirm'),
          message: this.$t('common.disable_attachment_confirm'),
          callback: () => {
            let payload = {
              id: attachment.id,
              data: {
                is_disabled: FLAG_YES
              },
              successCallback: () => {
                attachment.is_disabled = FLAG_YES
              }
            }

            this.$store.dispatch('attachmentfile/updateAttachmentStatus', payload)
          }
        })
      }
    },
    mounted: function () {
      this.$store.dispatch('attachmentfile/retrieveAttachmentUserList', {
        successCallback: () => {
          this.$store.dispatch('attachmentfile/retrievePickupRouteList', {
            successCallback: () => {
              // this.computePickupList()
            }
          })

          this.$store.dispatch('attachmentfile/retrieveDropRouteList', {
            successCallback: () => {
              // this.computeDropList()
            }
          })
        }
      })
    },
    computed: {
      ...mapState('attachmentfile', [
        'attachmentUserList',
        'attachmentForParentList',
        'attachmentForSubList',
        'attachmentForRouteList',
        'pickupRouteList',
        'dropRouteList',
        'attachmentForDropRouteList'
      ]),
      sortedAttachmentForParentList: function () {
        let sortedAttachmentForParentList = [].concat(this.attachmentForParentList)

        return sortedAttachmentForParentList.sort((before, after) => {
          return before.created_at < after.created_at ? 1 : before.created_at > after.created_at ? -1 : 0
        })
      },
      sortedAttachmentForSubList: function () {
        let sortedAttachmentForSubList = [].concat(this.attachmentForSubList)

        return sortedAttachmentForSubList.sort((before, after) => {
          return before.created_at < after.created_at ? 1 : before.created_at > after.created_at ? -1 : 0
        })
      },
      sortedAttachmentForRouteList: function () {
        let sortedAttachmentForRouteList = [].concat(this.attachmentForRouteList)

        return sortedAttachmentForRouteList.sort((before, after) => {
          if (!before.pickup_route_info) {
            return 1
          }

          if (!after.pickup_route_info) {
            return -1
          }

          if (before.pickup_route_info.name < after.pickup_route_info.name) {
            return -1
          }

          if (before.pickup_route_info.name > after.pickup_route_info.name) {
            return 1
          }

          return before.created_at < after.created_at ? 1 : before.created_at > after.created_at ? -1 : 0
        })
      },
      sortedAttachmentForDropRouteList: function () {
        let sortedAttachmentForDropRouteList = [].concat(this.attachmentForDropRouteList)

        return sortedAttachmentForDropRouteList.sort((before, after) => {
          if (!before.drop_route_info) {
            return 1
          }

          if (!after.drop_route_info) {
            return -1
          }

          if (before.drop_route_info.name < after.drop_route_info.name) {
            return -1
          }

          if (before.drop_route_info.name > after.drop_route_info.name) {
            return 1
          }

          return before.created_at < after.created_at ? 1 : before.created_at > after.created_at ? -1 : 0
        })
      },
      sortedPickupRouteList: function () {
        let sortedPickupRouteList = [].concat(this.pickupRouteList)

        return sortedPickupRouteList.sort((before, after) => {
          return before.name > after.name ? 1 : before.name < after.name ? -1 : 0
        })
      },
      sortedDropRouteList: function () {
        let sortedDropRouteList = [].concat(this.dropRouteList)

        return sortedDropRouteList.sort((before, after) => {
          return before.name > after.name ? 1 : before.name < after.name ? -1 : 0
        })
      }
    }
  }
</script>
<style lang="scss">
  .error-section {
    min-height: 1px;
  }

  .attachment-file-page {
    .b-form-file {
      width: 90%;
      text-align: left;
      overflow: hidden;
    }
  }
</style>
